import { Component, OnInit } from '@angular/core';
import { RestService } from 'src/app/services/rest/rest.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { User } from 'src/app/interfaces/user';
import { Car } from 'src/app/interfaces/car';
import { Carga } from 'src/app/interfaces/carga';
import { ProductByNAME, ProductById } from 'src/app/data/products';
import { ModalController, AlertController } from '@ionic/angular';
import { AddCargaComponent } from 'src/app/components/add-carga/add-carga.component';
import { StorageService } from 'src/app/services/storage/storage.service';
import { AcceptCargaComponent } from 'src/app/components/accept-carga/accept-carga.component';

@Component({
  selector: 'app-cargas',
  templateUrl: './cargas.page.html',
  styleUrls: ['./cargas.page.scss'],
})
export class CargasPage implements OnInit {
  repartidores: User[] = [];
  cars: Car[] = [];
  lines: Carga[] = [];
  currentUser: User = {} as User;
  products = [];

  columns = [
    {
      field: 'matricula',
      name: 'VEHICULO',
      width: 20
    },
    {
      field: 'repartidor',
      name: 'REPARTIDOR',
      width: 20
    },
    {
      field: 'isAccepted',
      name: 'Aceptada',
      width: 20,
      type: 'boolean',
      bolValues: {
        true: 'Sí',
        false: 'No'
      }
    },
    {
      field: 'closed',
      name: 'Entregue',
      width: 20,
      type: 'boolean',
      bolValues: {
        true: 'Sí',
        false: 'No'
      }
    },
    {
      field: 'cubito vogt',
      name: 'CUBITO VOGT',
      width: 15
    },
    {
      field: 'cubito scotsman',
      name: 'CUBITO SCOTSMAN',
      width: 15
    },
    {
      field: 'hielo pilee',
      name: 'HIELO PILEE',
      width: 15
    },
    {
      field: 'escama red',
      name: 'ESCAMA RED',
      width: 15
    },
    {
      field: 'escama cuad',
      name: 'ESCAMA CUAD',
      width: 15
    },
    {
      field: 'hielo cuadrado',
      name: 'HIELO CUADRADO',
      width: 15
    },
    {
      field: 'barra',
      name: 'BARRA',
      width: 15
    },
    {
      field: 'bloques',
      name: 'BLOQUES',
      width: 15
    },
    {
      field: 'hielo seco',
      name: 'HIELO SECO',
      width: 15
    },
    {
      field: 'hielo especial',
      name: 'HIELO ESPECIAL',
      width: 15
    },
    {
      field: 'cubo 5x5',
      name: 'CUBO 5X5',
      width: 15
    },
    {
      field: 'lingote 4x12',
      name: 'LINGOTE 4X12',
      width: 15
    },
    {
      field: 'esferas 6cm',
      name: 'ESFERAS 6CM',
      width: 15
    },
    {
      field: 'cubo 5,5 x 5,5',
      name: 'CUBO 5,5 X 5,5',
      width: 15
    },
    {
      field: 'cubo 5x7',
      name: 'CUBO 5X7',
      width: 15
    },
    {
      field: 'lingote 3x15',
      name: 'LINGOTE 3X15',
      width: 15
    },
    {
      field: 'esferas 3cm',
      name: 'ESFERAS 3CM',
      width: 15
    },
    {
      field: 'lote',
      name: 'LOTE',
      width: 15,
      input_type: 'text'
    },
    
    {
      field: 'action',
      name: 'acciones rápidas',
      width: 10,
      actions: [
        {
          type: 'view'
        },
        {
          type: 'delete',
          validate: 'closed',
          validateType: 'boolean'
        }, {
          type: 'next',
          validate: 'isAccepted',
          validateType: 'boolean'
        }
      ]
    }
  ];

  constructor(
    private rest: RestService,
    private storage: StorageService,
    private utils: UtilsService,
    private alert: AlertController,
    private modal: ModalController
  ) { }

  async ionViewWillEnter() {
    await this.getAllInfo();
    await this.getProducts();
    this.currentUser = await this.storage.getUser()
  }

  ngOnInit() {
  }

  async getProducts() {
    const resp: any = await this.rest.getProducts(1, 1000);
    if (resp.body && resp.body.records) {
      this.products = resp.body.records.filter(elem => (elem._id !== '5ef5e43bdd4795f0c32a1530')
        && elem._id !== '5ef5e43bdd4795f0c32a152f');
      console.log(this.products);
    }
  }

  async getAllInfo() {
    try {
      await this.utils.showLoading();
      await this.getAllRepartidores();
      await this.getAllVehicles();
      await this.getCargas();
      await this.utils.hideLoading();
    } catch (error) {
      console.log(error);
      await this.utils.hideLoading();
      await this.utils.showToast('Error cargando los datos', 'danger');
    }
  }

  async getCargas() {
    try {
      const resp: any = await this.rest.getCurrentCargas();
      console.log(resp);
      this.lines = [];
      if (resp !== false) {
        const result: Carga[] = resp.body.records;
        result.forEach(carga => {
          const insert: any = carga;
          insert.matricula = this.cars.filter(elem => elem._id === (insert.car as any))[0].matricula;
          console.log(this.repartidores);
          console.log(insert.user);
          console.log(carga);
          let user;
          if (insert.user && insert.user._id) {
            user = this.repartidores.filter(elem => elem._id === (insert.user as any)._id);
          } else {
            user = [{
              _id: '',
              firstName: null
            }];
          }
          console.log(insert);
          if (insert.furgoneta) {

            insert.start = insert.furgoneta.start;
            insert.end = insert.furgoneta.end;
            insert.units = insert.furgoneta.units;
          }
          insert.repartidor = user[0].firstName;
          (insert.user as any) = user[0]._id;
          carga.product.forEach(product => {
            const productName: string = ProductById(product._id).toLowerCase();
            insert[productName] = product.unit;
          });
          this.lines.push(insert);
        });
        console.log(this.lines);

        this.lines.forEach(line => {
          if (line.end) {
            const time = new Date(line.end).toLocaleTimeString('es-ES').slice(0, -3);
            line.end = new Date(line.end).toLocaleDateString('es-ES');
            line.end = line.end + ' - ' + time;
          }
          if (line.start) {
            const time = new Date(line.start).toLocaleTimeString('es-ES').slice(0, -3);
            line.start = new Date(line.start).toLocaleDateString('es-ES');
            line.start = line.start + ' - ' + time;
          }
        })
        // this.repartidores = this.repartidores.filter((el) => el.role === 'repartidor');
      } else {
        await this.utils.showToast('Error cargando las cargas', 'danger');
      }
    } catch (error) {
      console.log(error);
      await this.utils.showToast('Error cargando las cargas', 'danger');
    }
  }

  async getAllRepartidores() {
    try {
      const resp: any = await this.rest.getUsers(1, 1000);
      if (resp !== false) {
        this.repartidores = resp.body.records;
        this.repartidores = this.repartidores.filter((el) => el.role === 'repartidor');
      } else {
        await this.utils.showToast('Error cargando los repartidores', 'danger');
      }
    } catch (error) {
      console.log(error);
      await this.utils.showToast('Error cargando los repartidores', 'danger');
    }
  }

  async getAllVehicles() {
    try {
      const resp: any = await this.rest.getCars(1, 1000);
      if (resp !== false) {
        this.cars = resp.body.records;
      } else {
        await this.utils.showToast('Error cargando los vehículos', 'danger');
      }
    } catch (error) {
      console.log(error);
      await this.utils.showToast('Error cargando los vehículos', 'danger');
    }
  }

  async addNew() {
    console.log('add new');
    const modal = await this.modal.create({
      component: AddCargaComponent,
      componentProps: {
        repartidores: this.repartidores,
        cars: this.cars,
        cargas: this.lines,
        // Aquí la lógica de vehiculos/repartidores
      }
    });
    await modal.present();
    const result = await modal.onWillDismiss();

    if (result && result.data) {
      console.log(result.data);
      this.saveOne(result.data);
    }
  }

  async saveOne(data: any) {
    try {
      await this.utils.showLoading();
      const stockUpdate = [];
      const stockObj = [];
      const products = [];
      this.products.forEach(
        prod => {
          products.push({
            _id: prod._id,
            unit: parseInt(data[prod._id], 10) || 0
          });
          stockUpdate.push({
            product: prod._id,
            quantity: (parseInt(data[prod._id], 10) || 0) * -1,
            total: 0
          });
        }
      );
      stockObj.push({
        transaction: stockUpdate,
        creator: this.currentUser._id
      });
      // products.push({
      //   _id: '5eb9c9e3d0ca13a4332680dc',
      //   unit: parseInt(data['5eb9c9e3d0ca13a4332680dc'], 10) || 0
      // });
      // products.push({
      //   _id: '5eb9c9e3d0ca13a4332680db',
      //   unit: parseInt(data['5eb9c9e3d0ca13a4332680db'], 10) || 0
      // });
      // products.push({
      //   _id: '5eb9c9e3d0ca13a4332680d9',
      //   unit: parseInt(data['5eb9c9e3d0ca13a4332680d9'], 10) || 0
      // });
      // products.push({
      //   _id: '5eb9c9e3d0ca13a4332680da',
      //   unit: parseInt(data['5eb9c9e3d0ca13a4332680da'], 10) || 0
      // });
      // products.push({
      //   _id: '5ef5e43bdd4795f0c32a152b',
      //   unit: parseInt(data['5ef5e43bdd4795f0c32a152b'], 10) || 0
      // });
      // products.push({
      //   _id: '5ea75b95ece96f572f598255',
      //   unit: parseInt(data['5ea75b95ece96f572f598255'], 10) || 0
      // });
      // products.push({
      //   _id: '5ef5e43bdd4795f0c32a152c',
      //   unit: parseInt(data['5ef5e43bdd4795f0c32a152c'], 10) || 0
      // });
      // products.push({
      //   _id: '5ef5e43bdd4795f0c32a152d',
      //   unit: parseInt(data['5ef5e43bdd4795f0c32a152d'], 10) || 0
      // });
      // products.push({
      //   _id: '5ef5e43bdd4795f0c32a152e',
      //   unit: parseInt(data['5ef5e43bdd4795f0c32a152e'], 10) || 0
      // });
      // products.push({
      //   _id: '5ef5e43bdd4795f0c32a1531',
      //   unit: parseInt(data['5ef5e43bdd4795f0c32a1531'], 10) || 0
      // });

      // stockUpdate.push({
      //   transaction: [
      //     {
      //       product: '5eb9c9e3d0ca13a4332680dc',
      //       quantity: (parseInt(data['5eb9c9e3d0ca13a4332680dc'], 10) || 0) * -1,
      //       total: 0
      //     },
      //     {
      //       product: '5eb9c9e3d0ca13a4332680db',
      //       quantity: (parseInt(data['5eb9c9e3d0ca13a4332680db'], 10) || 0) * -1,
      //       total: 0
      //     },
      //     {
      //       product: '5eb9c9e3d0ca13a4332680d9',
      //       quantity: (parseInt(data['5eb9c9e3d0ca13a4332680d9'], 10) || 0) * -1,
      //       total: 0
      //     },
      //     {
      //       product: '5eb9c9e3d0ca13a4332680da',
      //       quantity: (parseInt(data['5eb9c9e3d0ca13a4332680da'], 10) || 0) * -1,
      //       total: 0
      //     },
      //     {
      //       product: '5ef5e43bdd4795f0c32a152b',
      //       quantity: (parseInt(data['5ef5e43bdd4795f0c32a152b'], 10) || 0) * -1,
      //       total: 0
      //     },
      //     {
      //       product: '5ea75b95ece96f572f598255',
      //       quantity: (parseInt(data['5ea75b95ece96f572f598255'], 10) || 0) * -1,
      //       total: 0
      //     },
      //     {
      //       product: '5ef5e43bdd4795f0c32a152c',
      //       quantity: (parseInt(data['5ef5e43bdd4795f0c32a152c'], 10) || 0) * -1,
      //       total: 0
      //     },
      //     {
      //       product: '5ef5e43bdd4795f0c32a152d',
      //       quantity: (parseInt(data['5ef5e43bdd4795f0c32a152d'], 10) || 0) * -1,
      //       total: 0
      //     },
      //     {
      //       product: '5ef5e43bdd4795f0c32a152e',
      //       quantity: (parseInt(data['5ef5e43bdd4795f0c32a152e'], 10) || 0) * -1,
      //       total: 0
      //     },
      //     {
      //       product: '5ef5e43bdd4795f0c32a1531',
      //       quantity: (parseInt(data['5ef5e43bdd4795f0c32a1531'], 10) || 0) * -1,
      //       total: 0
      //     },
      //   ]
      // });

      const elem: any = {};
      elem.product = products;
      elem.isAccepted = false;

      const newCarga: Carga = {
        car: data.car,
        user: data.responsable,
        lote: data.lote,
        product: products,
        creator: this.currentUser._id,
        furgoneta: {
          start: null,
          end: null,
          units: null
        }
      }

      const resp = await this.rest.editStockInBatch(stockObj); // It is a method that creates not update
      if (resp !== false) {
        // await this.utils.showToast('Stock actualizado correctamente', 'success');
      } else {
        await this.utils.hideLoading();
        await this.utils.showToast('Error al actualizar el stock', 'danger');
        return;
      }

      const respCarga: any = await this.rest.createCarga(newCarga);
      if (respCarga !== false) {
        console.log(respCarga);
        // await this.rest.createNotifications([newCarga.user], 'carga');
        await this.utils.hideLoading();
        await this.utils.showToast('Guardado con exito');
        /* setTimeout(
           () => window.location.reload()
           , 200);*/
        await this.getAllInfo();
      } else {
        await this.utils.hideLoading();
        await this.utils.showToast('Error al guardar', 'danger');
      }
    } catch (error) {
      console.log(error);
      await this.utils.hideLoading();
      await this.utils.showToast('Error al guardar', 'danger');
    }
  }

  async doAction(data) {
    console.log(data);
    const carga: Carga = data.line;
    if (data.action === 'delete') {
      await this.deleteItem(carga);
    }
    if (carga.closed) {
      if (data.action === 'view') {
        const alert = await this.alert.create({
          header: 'Información de la carga',
          message: '<b>INICIO: </b>' + ' ' + carga.start +
            '<br>' + '<b>FIN: </b>' + ' ' + carga.end + '<br>' +
            '<b>Unidades devueltas: </b>' + ' ' + carga.units,
          buttons: [
            {
              text: 'OK',
              role: 'cancel',
              cssClass: 'secondary'
            }
          ]
        });
        await alert.present();
      }
    } else {
      if (data.action === 'view') {
        const alert = await this.alert.create({
          header: 'Carga no cerrada todavía',
          buttons: [
            {
              text: 'OK',
              role: 'cancel',
              cssClass: 'secondary'
            }
          ]
        });
        await alert.present();
      }
    }

    if (!carga.acceptedAt && data.action === 'next') {
      await this.acceptCargaModal(carga);
    }
  }

  async acceptCargaModal(carga) {
    const modal = await this.modal.create({
      component: AcceptCargaComponent,
      cssClass: 'my-custom-class',
      componentProps: {
        carga
      }
    });
    await modal.present();

    const result: any = await modal.onWillDismiss();

    console.log(result);
    if (result && result.data && result.data.closed) {
      await this.utils.showLoading();
      const resp = await this.rest.acceptCarga(carga._id);
      await this.utils.hideLoading();
      if (resp) {
        await this.utils.showToast('Carga aceptada correctamente', 'success');
        setTimeout(
          () => {
            location.reload();
          }, 1000);
      } else {
        await this.utils.showToast('Error aceptando carga', 'danger');
      }
    }
  }

  async deleteItem(carga: any) {
    console.log(carga.product);
    const alert = await this.alert.create({
      header: '¿Borrar?',
      message: 'Borrar carga de ' + carga.repartidor,
      buttons: [
        {
          text: 'No',
          role: 'cancel',
          cssClass: 'secondary'
        }, {
          text: 'Sí',
          handler: async () => {
            console.log('Item to remove!!!');
            await this.utils.showLoading();
            await this.rest.deleteCarga(carga._id);
            const stock = this.createStockObject(carga.product);
            await this.rest.editStockInBatch(stock); // It is a method that creates not update
            await this.utils.hideLoading();
            await this.getAllInfo();
          }
        }
      ]
    });
    await alert.present();
  }


  createStockObject(data: any) {
    console.log(data);
    const stockUpdate = [];
    stockUpdate.push({
      transaction: [
        {
          product: '5eb9c9e3d0ca13a4332680dc',
          quantity: (this.getUnits('5eb9c9e3d0ca13a4332680dc', data) || 0),
          total: 0
        },
        {
          product: '5eb9c9e3d0ca13a4332680db',
          quantity: (this.getUnits('5eb9c9e3d0ca13a4332680db', data) || 0),
          total: 0
        },
        {
          product: '5eb9c9e3d0ca13a4332680d9',
          quantity: (this.getUnits('5eb9c9e3d0ca13a4332680d9', data) || 0),
          total: 0
        },
        {
          product: '5eb9c9e3d0ca13a4332680da',
          quantity: (this.getUnits('5eb9c9e3d0ca13a4332680da', data) || 0),
          total: 0
        },
        {
          product: '5ef5e43bdd4795f0c32a152b',
          quantity: (this.getUnits('5ef5e43bdd4795f0c32a152b', data) || 0),
          total: 0
        },
        {
          product: '5ea75b95ece96f572f598255',
          quantity: (this.getUnits('5ea75b95ece96f572f598255', data) || 0),
          total: 0
        },
        {
          product: '5ef5e43bdd4795f0c32a152c',
          quantity: (this.getUnits('5ef5e43bdd4795f0c32a152c', data) || 0),
          total: 0
        },
        {
          product: '5ef5e43bdd4795f0c32a152d',
          quantity: (this.getUnits('5ef5e43bdd4795f0c32a152d', data) || 0),
          total: 0
        },
        {
          product: '5ef5e43bdd4795f0c32a152e',
          quantity: (this.getUnits('5ef5e43bdd4795f0c32a152e', data) || 0),
          total: 0
        },
        {
          product: '5ef5e43bdd4795f0c32a1531',
          quantity: (this.getUnits('5ef5e43bdd4795f0c32a1531', data) || 0),
          total: 0
        },
        {
          product: '6509a1e01bb0978fd8b5b15f',
          quantity: (this.getUnits('6509a1e01bb0978fd8b5b15f', data) || 0),
          total: 0
        },
        {
          product: '6509a4241bb0978fd8b5b161',
          quantity: (this.getUnits('6509a4241bb0978fd8b5b161', data) || 0),
          total: 0
        },
        {
          product: '650dbb3eb78327095c20a226',
          quantity: (this.getUnits('650dbb3eb78327095c20a226', data) || 0),
          total: 0
        },
        {
          product: '650aae4834900b974d3fba94',
          quantity: (this.getUnits('650aae4834900b974d3fba94', data) || 0),
          total: 0
        },
        {
          product: '650aae7934900b974d3fba95',
          quantity: (this.getUnits('650aae7934900b974d3fba95', data) || 0),
          total: 0
        },
        {
          product: '650aae9a34900b974d3fba96',
          quantity: (this.getUnits('650aae9a34900b974d3fba96', data) || 0),
          total: 0
        },
        {
          product: '650aaebe34900b974d3fba97',
          quantity: (this.getUnits('650aaebe34900b974d3fba97', data) || 0),
          total: 0
        },
      ],
      creator: this.currentUser._id
    });
    return stockUpdate;
  }

  getUnits(key: string, elems: any[]) {
    let result: any = elems.filter(e => e._id === key);
    result = result[0];
    return result.unit;
  }

  async refreshPage() {
    await this.getAllInfo();
    await this.getProducts();
    this.currentUser = await this.storage.getUser()
  }
}
